import React, { useEffect, useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../../assets/css/addEuipment.css";
import { ToastContainer, toast } from "react-toastify";
import fetchWrapper from "./../../AuthMiddleware/FetchWrapper";
import Loader from "../../Components/LoaderAndSpinner/Loader";

const AddAssetGroup = () => {
  const [assetGroupCode, setAssetGroupCode] = useState("");
  const [assetGroupName, setAssetGroupName] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [equipments, setEquipments] = useState([]);
  const [checkedItems, setCheckedItems] = useState([]);
  const [allChecked, setAllChecked] = useState(false);

  const fetchEquipments = useCallback(async () => {
    try {
      const apiUrl = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/equipment/getall`;
      const data = await fetchWrapper(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({}),
      });
      setEquipments(data.data);
    } catch (error) {
      console.error("Error fetching equipments:", error);
    }
  }, []);

  useEffect(() => {
    fetchEquipments();
  }, [fetchEquipments]);

  const handleRowCheckboxChange = (id) => {
    setCheckedItems((prevCheckedItems) => {
      const newCheckedItems = [...prevCheckedItems];
      const currentIndex = newCheckedItems.indexOf(id);

      if (currentIndex === -1) {
        newCheckedItems.push(id);
      } else {
        newCheckedItems.splice(currentIndex, 1);
      }

      setAllChecked(newCheckedItems.length === equipments.length);
      return newCheckedItems;
    });
  };

  const handleHeaderCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setCheckedItems(equipments.map((equipment) => equipment._id));
    } else {
      setCheckedItems([]);
    }
    setAllChecked(isChecked);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const trimmedTemplateName = assetGroupName.trim();
      const trimmedTemplateCode = assetGroupCode.trim();
      // if (trimmedTemplateName === "") {
      //     setLoading(false);
      //     toast.error("Please enter asset group name.");
      //     return;
      // }
      // if (trimmedTemplateCode === "") {
      //     setLoading(false);
      //     toast.error("Please enter asset group code.");
      //     return;
      // }

      const checkedItemsString = checkedItems.join(",");
      await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset-group/create`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            asset_group_name: trimmedTemplateName,
            asset_group_code: trimmedTemplateCode,
            equipments: checkedItemsString,
          }),
        }
      );

      setLoading(false);
      toast.success("Asset Group saved successfully");
      navigate("/all_assets_group");
    } catch (error) {
      setLoading(false);
      // toast.error("Select Atleast One Equipement");
      if (error.response) {
        const errorData = error.response;
        if (errorData.errors.equipments) {
          toast.error("Select Atleast One Equipement");

        }

        setErrors(errorData.errors || {});
        // toast.error(errorData.message || "Error adding department");
      } else {
        toast.error("Error saving asset group");
      }
    }
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div>
          <div className="container">
            <div className="pt-3 pb-0 d-flex justify-content-between">
              <div>
                <h5>Add Asset Group</h5>
                <nav
                  className="breadcrumb-nav show-breadcrumb"
                  aria-label="breadcrumb"
                >
                  <ol className="breadcrumb template-breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="#">My Assets</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/all_assets_group">Asset Groups</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Add Asset Group
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
            <div className="addEuipment">
              <div>
                <div className="addEuipment-header">
                  <h4>Add Asset Group</h4>
                </div>
                <form onSubmit={handleSubmit}>
                  <div className="addEuipment-form">
                    <div className="d-flex gap-3">
                      <div className="col d-flex flex-column addEuipment-form-col">
                        <label className="addEuipment-form-text">
                          Asset Group Code <span className="text-danger"> *</span>
                        </label>
                        <input
                          className={`form-control ${errors.asset_group_code ? "is-invalid" : ""
                            }`}
                          placeholder="Asset Group Code"
                          style={{ padding: "8px 8px", height: "48px" }}
                          value={assetGroupCode}
                          onChange={(e) => setAssetGroupCode(e.target.value)}
                        />
                        {errors.asset_group_code && (
                          <div className="invalid-feedback">
                            {errors.asset_group_code}
                          </div>
                        )}
                      </div>
                      <div className="col d-flex flex-column addEuipment-form-col">
                        <label className="addEuipment-form-text">
                          Asset Group Name <span className="text-danger"> *</span>
                        </label>
                        <input
                          className={`form-control ${errors.asset_group_name ? "is-invalid" : ""
                            }`}
                          placeholder="Asset Group Name"
                          style={{ padding: "8px 8px", height: "48px" }}
                          value={assetGroupName}
                          onChange={(e) => setAssetGroupName(e.target.value)}
                        />
                        {errors.asset_group_name && (
                          <div className="invalid-feedback">
                            {errors.asset_group_name}
                          </div>
                        )}
                      </div>
                    </div>
                    <div style={{ marginTop: "-10px" }}>
                      <div className="table-responsive">
                        <table className="table  align-middle table-text">
                          <thead className="table-head align-middle">
                            <tr>
                              <th className="table-check">
                                <input
                                  type="checkbox"
                                  checked={allChecked}
                                  onChange={handleHeaderCheckboxChange}
                                />
                              </th>
                              <th className="col">ID</th>
                              <th className="col">Equipment Code</th>
                              <th className="col">Equipment Name</th>
                              <th className="col">Capacity</th>
                            </tr>
                          </thead>
                          <tbody>
                            {equipments.map((equipment, index) => (
                              <tr
                                key={equipment._id}
                                className={
                                  equipment.status ? "" : "disabled text-muted"
                                }
                              >
                                <td className="table-check">
                                  <input
                                    type="checkbox"
                                    checked={checkedItems.includes(
                                      equipment._id
                                    )}
                                    onChange={() =>
                                      handleRowCheckboxChange(equipment._id)
                                    }
                                  />
                                </td>
                                <td className="col">{index + 1}</td>
                                <td>{equipment.equipment_code || ""}</td>
                                <td>{equipment.equipment_name || ""}</td>
                                <td>{equipment.capacity || ""}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>

                      </div>
                    </div>
                  </div>

                  <div className="addEuipment-footer">
                    <button
                      type="button"
                      className="addEuipment-discard-btn"
                      onClick={() => navigate("/all_assets_group")}
                    >
                      Discard
                    </button>
                    <button type="submit" className="addEuipment-update-btn">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
          />
        </div>
      )}
    </>
  );
};

export default AddAssetGroup;
